var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('change-password',{attrs:{"userId":_vm.userId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }